import has from 'lodash/has'
import { TextareaHTMLAttributes } from 'react'
import { ErrorMessage, FieldProps } from 'formik'

import styles from './TextArea.module.css'
import { InvalidMessage } from '../InvalidMessage'

interface TextAreaProps
  extends Partial<FieldProps>,
    Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'form'> {
  showErrors?: boolean
}

export function TextArea(props: TextAreaProps) {
  const { showErrors = true, field, form, className, ...rest } = props

  let constructedClassName = styles.textarea
  if (
    has(form?.touched ?? {}, field?.name ?? '') &&
    has(form?.errors ?? {}, field?.name ?? '')
  ) {
    constructedClassName += ` ${styles.error}`
  }
  if (className) {
    constructedClassName += ` ${className}`
  }

  return (
    <>
      <textarea className={constructedClassName} {...field} {...rest} />
      {showErrors && form && (
        <ErrorMessage component={InvalidMessage} name={field?.name ?? ''} />
      )}
    </>
  )
}
